import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'TRIP_FORM_CHANGED';
const TRIP_APPLIED_EVENT = 'TRIP_APPLIED';
const TRIP_GENERATED_EVENT = 'TRIP_GENERATED';
const context = {
    trip: {},
    pendingTrip: null,
    formStatus: {
        pending: false,
        completed: false,
        success: false,
    },
};
function mapTripUpdate(currentTrip, updatedTrip) {
    if (!currentTrip) {
        return updatedTrip;
    }
    const legs = updatedTrip.legs.map((leg, legIndex) => {
        const existingLeg = currentTrip.legs[legIndex];
        const stops = leg.stops.map((stop, stopIndex) => {
            const existingStop = existingLeg.stops[stopIndex];
            const equipments = [...existingStop.equipments];
            return Object.assign(Object.assign({}, stop), { equipments });
        });
        const { carrier_id, carrier, } = existingLeg;
        return Object.assign(Object.assign({}, leg), { carrier_id,
            carrier,
            stops });
    });
    const trip = Object.assign(Object.assign({}, updatedTrip), { legs });
    return trip;
}
const TripFormStore = assign({}, EventEmitter.prototype, {
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    emitTripApplied() {
        this.emit(TRIP_APPLIED_EVENT);
    },
    emitTripGenerated() {
        this.emit(TRIP_GENERATED_EVENT);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addTripAppliedEventListener(callback) {
        this.on(TRIP_APPLIED_EVENT, callback);
    },
    removeTripAppliedEventListener(callback) {
        this.removeListener(TRIP_APPLIED_EVENT, callback);
    },
    addTripGeneratedEventListener(callback) {
        this.on(TRIP_GENERATED_EVENT, callback);
    },
    removeTripGeneratedEventListener(callback) {
        this.removeListener(TRIP_GENERATED_EVENT, callback);
    },
    onTripSaveRequest(trip) {
        const formStatus = {
            pending: true,
            completed: false,
            success: false,
            error: null,
        };
        context.pendingTrip = trip;
        context.formStatus = formStatus;
        this.emitChange();
    },
    onTripSaveSuccess(updatedTrip) {
        const formStatus = {
            pending: false,
            completed: true,
            success: true,
            error: null,
        };
        const trip = mapTripUpdate(context.pendingTrip, updatedTrip);
        context.trip = trip;
        context.pendingTrip = null;
        context.formStatus = formStatus;
        this.emitChange();
    },
    onTripSaveFail(error) {
        const formStatus = {
            pending: false,
            completed: true,
            success: false,
            error,
        };
        context.formStatus = formStatus;
        this.emitChange();
    },
    getTripContext() {
        return context;
    },
});
TripFormStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.CREATE_TRIP_SUCCESS:
        case ActionTypes.UPDATE_TRIP_SUCCESS:
            TripFormStore.onTripSaveSuccess(action.trip);
            break;
        case ActionTypes.CREATE_TRIP_FAIL:
        case ActionTypes.UPDATE_TRIP_FAIL:
        case ActionTypes.SAVE_AND_APPLY_TRIP_FAIL:
        case ActionTypes.GENERATE_TRIP_FAIL:
            TripFormStore.onTripSaveFail(action.error);
            break;
        case ActionTypes.CREATE_TRIP_REQUEST:
        case ActionTypes.UPDATE_TRIP_REQUEST:
        case ActionTypes.SAVE_AND_APPLY_TRIP_REQUEST:
        case ActionTypes.GENERATE_TRIP_REQUEST:
            TripFormStore.onTripSaveRequest(action.trip);
            break;
        case ActionTypes.SAVE_AND_APPLY_TRIP_SUCCESS:
            TripFormStore.onTripSaveSuccess(action.trip);
            TripFormStore.emitTripApplied();
            break;
        case ActionTypes.GENERATE_TRIP_SUCCESS:
            TripFormStore.onTripSaveSuccess(action.trip);
            TripFormStore.emitTripGenerated();
            break;
        default:
            break;
    }
});
export default TripFormStore;
